import { auditReportsExecuteLtxMatchesReport } from '@mi-front/api-v2';
import { DateStr, today } from '@mi-front/core';
import { ReportView } from '../../../../../../../../core/reports/components/ReportView';
import { LtxMatchesReportEmptyState } from './LtxMatchesReportEmptyState';
import { LtxMatchesReportForm } from './LtxMatchesReportForm';
import { LtxMatchesReportResult } from './LtxMatchesReportResult';
import { LtxMatchesReport } from './types';
import { Station } from '@app/core/types/stations';

export function LtxMatchesReportView(p: { station: Station }) {
  const resetValues = {
    stationId: p.station.slug,
    date: today() as DateStr,
  };

  return (
    <ReportView<LtxMatchesReport>
      defaultValues={resetValues}
      reportFn={(values) => {
        return auditReportsExecuteLtxMatchesReport({
          stationId: p.station.slug,
          date: values.date,
          customId: values.customId || undefined,
        });
      }}
      Form={LtxMatchesReportForm}
      Result={LtxMatchesReportResult}
      emptyResult={<LtxMatchesReportEmptyState />}
    />
  );
}
